"use client";

import { formatDistanceToNow } from "date-fns";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { formatStoredTimestamp, parseFlexibleDate } from "@/utils/date-utils";

export function TimestampCell({ value }: { value: string | null }) {
  if (!value) {
    return <span className="text-muted-foreground">—</span>;
  }

  const display = formatStoredTimestamp(value);
  if (!display) {
    return <span className="text-muted-foreground">Invalid date</span>;
  }

  const instant = parseFlexibleDate(value);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="tabular-nums">{display}</span>
      </TooltipTrigger>
      <TooltipContent>
        <p className="font-mono text-xs">{value}</p>
        {instant ? (
          <p className="text-muted-foreground">{formatDistanceToNow(instant, { addSuffix: true })}</p>
        ) : null}
      </TooltipContent>
    </Tooltip>
  );
}
